module.exports = __webpack_public_path__ + "static/grafika7-2eae0935e74490ec8cac4c38abf72b24.png";